import {useState} from 'react';
import styles from './SlotMachine.module.css';
import './styles.css';

import {SlotMachineGraphic} from './components/Graphic';
import Video from './components/Video';

import logo from 'assets/games/theme-mrr/headerLogo.png';
import clouds from '../../../assets/games/theme-mrr/clouds.png';
import tape from '../../../assets/games/theme-mrr/tape.png';
import bushCenter from 'assets/games/theme-mrr/slot/footer/bushCenter.png';
import bushLeft from 'assets/games/theme-mrr/slot/footer/bushLeft.png';
import bushRight from 'assets/games/theme-mrr/slot/footer/bushRight.png';
import SlotMachineLayout from '../slot-machine-wrapper/SlotMachineLayout';

export default function SlotMachineMrr() {
    const [bgMusicMuted, setBgMusicMuted] = useState(false);

    return (
        <div className={styles.slotMachineContainer}>
            <SlotMachineLayout
                BgWrapper={({children}) => (
                    <div className={styles.slotMachineBg}>
                        {children}
                    </div>
                )}

                InnerWrapper={({children}) => (
                    <div className={styles.SlotMachineInnerContainer}>
                        {children}
                    </div>
                )}
                background={
                    <>
                        <div className={styles.SlotMachineCloudsWrapper}>
                            <img src={clouds} alt="" className={styles.SlotMachineCloud}/>
                            <img src={clouds} alt="" className={styles.SlotMachineCloud}/>
                        </div>
                        <div className={styles.SlotMachineTapeLeftWrapper}>
                            <img src={tape} alt="" className={styles.SlotMachineTapeLeft}/>
                            <img src={tape} alt="" className={styles.SlotMachineTapeLeft}/>
                        </div>

                        <div className={styles.SlotMachineTapeRightWrapper}>
                            <img src={tape} alt="" className={styles.SlotMachineTapeRight}/>
                            <img src={tape} alt="" className={styles.SlotMachineTapeRight}/>
                        </div>
                    </>
                }

                graphic={
                    <SlotMachineGraphic/>
                }

                header={
                    <img src={logo} alt="LMCT+" className={styles.SlotMachineLogo}/>

                }

                video={
                    <Video bgMusicMuted={bgMusicMuted}/>
                }

                footer={
                    <div className={styles.SlotMachineFooter}>
                        <img src={bushLeft} alt="LMCT+" className={styles.SlotMachineFooterLeftBush}/>
                        <img src={bushCenter} alt="LMCT+" className={styles.SlotMachineFooterCenterBush}/>
                        <img src={bushRight} alt="LMCT+" className={styles.SlotMachineFooterRightBush}/>
                    </div>
                }

            />
        </div>
    );
}
